import React from 'react';
import Tooltip from '@prisjakt/ui-tooltip-new';
import * as S from './styles';

type OwnProps = {
  className?: string;
  show?: boolean;
  countryCode: string;
  altText?: string;
  title?: string;
  showTitleAsTooltip?: boolean;
};

const CountryFlag = ({
  className,
  show = true,
  countryCode,
  altText,
  title,
  showTitleAsTooltip = true,
}: OwnProps) => {
  if (!show) {
    return null;
  }

  const size = 16;

  const renderImage = () => {
    return (
      <S.Image
        title={altText}
        alt={altText}
        size={size}
        src={`https://cdn.pji.nu/g/rfe/icons/flags/${size}x11/${countryCode}.gif`}
      />
    );
  };

  return (
    <>
      {showTitleAsTooltip ? (
        <Tooltip placement="left" title={title} className={className}>
          {renderImage()}
        </Tooltip>
      ) : (
        <S.CountryFlag className={className}>
          {renderImage()}
          <S.Text>{title}</S.Text>
        </S.CountryFlag>
      )}
    </>
  );
};

export default CountryFlag;
